import React, { useEffect, useState } from 'react'
import OTPInput from './OTPInput'
import { useSession } from 'src/features/auth'
import { useTranslation } from 'react-i18next';
import TextInput from 'src/components/TextInput';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from 'src/components/Button';

const _6DigitsMessage = "קוד אימות חייב להיות בעל 6 ספרות (0-9)";

const validator = z.object({
    otp: z.string().trim().min(6, _6DigitsMessage).max(6, _6DigitsMessage).refine(val => !isNaN(Number(val)), _6DigitsMessage)
})
type OTPFormInput = z.infer<typeof validator>;

const VerifyCodeForm = () => {

    const { verifyOTP, cancelSignIn } = useSession();

    const { register, handleSubmit, formState: { isSubmitting } } = useForm<OTPFormInput>({
        resolver: zodResolver(validator)
    });

    const onSubmit = async (input: OTPFormInput) => {
        await verifyOTP(`${input.otp}`)
    }

    const { t } = useTranslation()

    return (
        <React.Fragment>
            <form className='flex flex-col items-center font-Inter space-y-6' onSubmit={handleSubmit(onSubmit)}>
                <p className='text-dark text-center text-xs font-semibold px-20'>
                    {t("Please check your SMS inbox for a message from us. Your code should arrive shortly.")}
                </p>
                <div className='py-2'>
                    <TextInput inputProps={{ ...register("otp") }} center />
                </div>
                <div className='flex'>
                    <Button loading={isSubmitting} disabled={isSubmitting} type="submit">
                        אימות
                    </Button>
                </div>
                <p className='text-[#9a9fa5] text-xs font-semibold gap-x-1'>
                    <span>{t("Didn't receive the code?")}</span>
                    <a
                        href='#'
                        className='text-dark text-xs font-bold'
                    >{t("Resend")}</a>
                </p>


            </form>
        </React.Fragment>
    )
}

export default VerifyCodeForm